export default {"src":"/_next/static/media/elf_f_purple.664a9885.svg","height":600,"width":340,"blurWidth":0,"blurHeight":0};